const config = {
  "development": {
      "HOST": "http://localhost:3097",
      "PROCHECK_HOST":"https://ch-api-procheck.medibuddy.in",
      "FUSER_HOST":"https://fuser.medibuddy.in",
      "REQUEST_URL": "https://stg-integration-plus.medibuddy.in/Locus/GetRequestBasicDetails?requestId=",
    },
  "staging": {
      "HOST": "https://insurance-pushertest.medibuddy.in",
      "PROCHECK_HOST":"https://ch-api-procheck.medibuddy.in",
      "LAMBDA_HOST": "https://7i6ncxviq4.execute-api.ap-south-1.amazonaws.com/dev",
      "FUSER_HOST":"https://fuser.medibuddy.in",
      "BUCKET_URL": "https://dev-telemer.s3.ap-south-1.amazonaws.com/"
  },
  "production": {
      "HOST": "https://insurance-pusher.medibuddy.in",
      "PROCHECK_HOST":"https://ch-api-procheck.medibuddy.in",
      "FUSER_HOST":"https://fuser.medibuddy.in",
      "REQUEST_URL": "https://stg-integration-plus.medibuddy.in/Locus/GetRequestBasicDetails?requestId=",
  }
}

module.exports = config;